import "../css/BlogList.css"
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from 'swiper'
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase"; // firebase.jsのインポート

interface post {
  title: string;
  date: string;
  text: string;
  image: string[];
}

export const BlogList = () => {
  logEvent(analytics, 'tap_BlogList', { custom_param: 'tap call triggered' });
  const isMobile = window.innerWidth <= 799;
  const history = useHistory();
  const [posts, setPosts] = useState<post[]>([]);
  useEffect(() => {
    // JSONファイルを読み込む
    fetch("../../static-data/blog_data.json")
      .then((response) => response.json())
      .then((data) => {
        setPosts(data); // 取得したデータをstateに保存
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, []); // コンポーネントがマウントされたときに実行

  const openDetailClick = (index: number) => {
    history.push(`/BlogDetail/${index}`);
  };

  const defaultImage = '../../static-data/default-image.webp'; // デフォルト画像のパス
  return (
    <>
      <h1>ブログ一覧</h1>
      <div className='blog-list-backgroud'>
        <div>
          <h2 style={{
            "color": "black",
            "fontSize": "30px",
            "textShadow": "2px 2px 4px rgba(0, 0, 0, 0.7)",
            "margin": "0 0 0 20px"
          }}>
            ALL Posts</h2>
          {Object.values(posts).map((post, index) => (
            <div
              key={index}
              onClick={() => openDetailClick(index)}
              className="blog-list-container"
            >
              <div className="blog-list-img">
                {isMobile && (
                  <div className="blog-list-text">
                    <h1>{post.title}</h1>
                    {post.text.split("\n").slice(0, 3).map((line, index, arr) => (
                      <span key={index}>
                        {line}
                        {index === arr.length - 1 && post.text.split("\n").length > 3 && " ..."}
                        <br />
                      </span>
                    ))}
                    <div className="read-more">続きを読む {'>'}</div>
                  </div>
                )}
                <Swiper
                  spaceBetween={0} // スライド間のスペース
                  slidesPerView={1} // 1度に表示するスライド数
                  pagination={{ clickable: true }} // ページネーションを有効にする
                  modules={[Navigation, Pagination]}
                >
                  {post.image.length === 0 ?
                    <img src={defaultImage} alt="ship" />
                    : post.image.map((image, ind) => (
                      <SwiperSlide key={ind}>
                        <img
                          src={image}
                          alt={`${ind + 1}`}
                        />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
              {!isMobile && (
                <div className="blog-list-text">
                  <h1>{post.title}</h1>
                  {post.text.split("\n").slice(0, 5).map((line, index, arr) => (
                    <span key={index}>
                      {line}
                      {index === arr.length - 1 && post.text.split("\n").length > 5 && " ..."}
                      <br />
                    </span>
                  ))}
                  <div className="read-more">続きを読む {'>'}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
